module.exports = __webpack_public_path__ + "static/media/icon-risk-score-white.0a2518c8.svg";